import { coreApi as api } from "./Core/BaseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    removeBackground: build.mutation<
      RemoveBackgroundApiResponse,
      RemoveBackgroundApiArg
    >({
      query: (queryArg) => ({
        url: `/imageops/removebg`,
        method: "POST",
        body: queryArg.removeBackgroundRequest,
      }),
    }),
    removeBackgroundPaid: build.mutation<
      RemoveBackgroundPaidApiResponse,
      RemoveBackgroundPaidApiArg
    >({
      query: (queryArg) => ({
        url: `/imageops/paid/removebg`,
        method: "POST",
        body: queryArg.removeBackgroundRequest,
      }),
    }),
    removeBackground1: build.mutation<
      RemoveBackground1ApiResponse,
      RemoveBackground1ApiArg
    >({
      query: (queryArg) => ({
        url: `/imageops/crop`,
        method: "POST",
        body: queryArg.cropImageRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type RemoveBackgroundApiResponse =
  /** status 200 OK */ RemoveBackgroundResponse;
export type RemoveBackgroundApiArg = {
  removeBackgroundRequest: RemoveBackgroundRequest;
};
export type RemoveBackgroundPaidApiResponse =
  /** status 200 OK */ RemoveBackgroundResponse;
export type RemoveBackgroundPaidApiArg = {
  removeBackgroundRequest: RemoveBackgroundRequest;
};
export type RemoveBackground1ApiResponse =
  /** status 200 OK */ CropImageResponse;
export type RemoveBackground1ApiArg = {
  cropImageRequest: CropImageRequest;
};
export type FileProps = {
  id?: string;
  name?: string;
  uploaded?: boolean;
  summary?: string;
  create_date?: number;
  file_name?: string;
  file_type?: string;
};
export type RemoveBackgroundResponse = {
  backgroundRemovedFile?: FileProps;
};
export type RemoveBackgroundRequest = {
  imageFileId: string;
};
export type CropImageResponse = {
  croppedFile?: FileProps;
};
export type CropImageRequest = {
  imageFileId: string;
  mode: string;
};
export const {
  useRemoveBackgroundMutation,
  useRemoveBackgroundPaidMutation,
  useRemoveBackground1Mutation,
} = injectedRtkApi;
